import Vue from 'vue';
import ClientOnly from 'vue-client-only';
import '@mtntop/utils/src/utils/prototypes';
// global components for app
Vue.component('client-only', ClientOnly);
Vue.component('loader', () => import('@/components/Loader'));
